import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'app/appStore';
import { setFilter } from 'entities/Report';
import { EFilters } from 'features/Filters';

export const useReportsSlice = () => {
	const dispatch = useDispatch();

	return {
		...useSelector((s: RootState) => s.reportsSlice),
		setFilter: (payload: { name: EFilters; value: string | null }) => dispatch(setFilter(payload)),
	};
};
